import {NgModule} from "@angular/core";
import {Route, RouterModule, Routes} from "@angular/router";
import {DcSubRoutes} from "./dc/dc.route";
import {JbSubRoutes} from "./jb/jb.route";
import {XhSubRoutes} from "./xh/xh.route";
import {XxSubRoutes} from "./xx/xx.route";


export function getRouters(): { name: string; routeMethod: () => Routes }[] {
    return [
        {name : "dc", routeMethod: DcSubRoutes },
        {name : "jb", routeMethod: JbSubRoutes },
        {name : "xh", routeMethod: XhSubRoutes },
        {name : "xx", routeMethod: XxSubRoutes },
    ];
}

function collectSubRoutes(): Route[] {
    const routes: Route[] = [];
    const crmRouters = getRouters();
    for (const router of crmRouters) {
        const subRoutes = router.routeMethod();
        if (subRoutes) {
            routes.push(...subRoutes);
        }
    }
    return routes;
}

const routes: Routes = [
    {
        path: '',
        children: collectSubRoutes(),
    },
];
@NgModule({
    imports: [RouterModule.forChild(routes)], // ✅ forChild for lazy module
    exports: [RouterModule],
})
export class FeatureTechRoutingModule {}
